import { lazyTool } from "../lazy";
import type { ToolDefinition } from "../types";

export const webTools: ToolDefinition[] = [
  {
    id: "http-status",
    name: "HTTP Status Codes",
    description: "Search HTTP status codes from 1xx to 5xx with plain-language explanations.",
    category: "web",
    keywords: ["response", "error", "404", "redirect", "reference"],
    component: lazyTool(() => import("./http-status")),
  },
  {
    id: "curl-converter",
    name: "cURL to Code",
    description: "Convert a cURL command into fetch, Python, Go, or Node request code.",
    category: "web",
    keywords: ["curl", "request", "http", "python", "go", "node"],
    component: lazyTool(() => import("./curl-converter")),
  },
  {
    id: "user-agent",
    name: "User-Agent Parser",
    description: "Parse a user agent string into browser, engine, operating system, and device details.",
    category: "web",
    keywords: ["ua", "browser", "device", "detect", "header"],
    component: lazyTool(() => import("./user-agent")),
  },
  {
    id: "subnet-calculator",
    name: "IP Subnet Calculator",
    description: "Calculate IPv4 network, broadcast, mask, wildcard, and usable host ranges from CIDR.",
    category: "web",
    keywords: ["cidr", "ipv4", "network", "netmask", "broadcast"],
    component: lazyTool(() => import("./subnet-calculator")),
  },
  {
    id: "url-parser",
    name: "URL Parser & Builder",
    description: "Break a URL into its components and edit query parameters in a live builder.",
    category: "web",
    keywords: ["uri", "query", "parameters", "origin", "path"],
    component: lazyTool(() => import("./url-parser")),
  },
  {
    id: "port-reference",
    name: "Port Reference",
    description: "Look up common TCP and UDP ports and the services that use them.",
    category: "web",
    keywords: ["network", "service", "tcp", "udp", "socket"],
    component: lazyTool(() => import("./port-reference")),
  },
  {
    id: "dns-lookup",
    name: "DNS Lookup",
    description: "Resolve A, AAAA, CNAME, MX, TXT, NS, and SOA records through Cloudflare DNS over HTTPS.",
    category: "web",
    keywords: ["doh", "domain", "resolve", "records", "nameserver"],
    component: lazyTool(() => import("./dns-lookup")),
  },
  {
    id: "websocket-tester",
    name: "WebSocket Tester",
    description: "Connect to a WebSocket URL, send text messages, and inspect a timestamped event log.",
    category: "web",
    keywords: ["ws", "wss", "socket", "realtime", "messages"],
    component: lazyTool(() => import("./websocket-tester")),
  },
  {
    id: "http-headers",
    name: "HTTP Header Inspector",
    description: "Parse raw request or response headers and review cookies, duplicates, and security headers.",
    category: "web",
    keywords: ["cookies", "security", "request", "response", "inspect"],
    component: lazyTool(() => import("./http-headers")),
  },
  {
    id: "meta-tags",
    name: "Meta Tag Generator",
    description: "Generate escaped title, description, Open Graph, Twitter, and robots meta tags.",
    category: "web",
    keywords: ["seo", "opengraph", "twitter", "social", "canonical"],
    component: lazyTool(() => import("./meta-tags")),
  },
];
